import React from 'react';

import { useSelector } from 'react-redux';

import { DisclaimerText, Text } from 'reaxl';

import vdpResultsDuck from '@/ducks/vdp/vdpResultsDuck.js';

function DealerDisclosureContainer() {
    const { owner: {
        disclaimer,
        privateSeller,
    } = {} } = useSelector(vdpResultsDuck.selectors.getVdpActiveInventory);

    if (!disclaimer) return null;

    return (
        <DisclaimerText
            componentClass="p"
            withContrast
        >
            {privateSeller && <Text weight="bold">Vehicles are sold as-is, except when state law requires an implied warranty.</Text>}
            {' '}
            {!privateSeller && 'Dealer Disclosure: '}
            {disclaimer}
        </DisclaimerText>
    );
}

export default React.memo(DealerDisclosureContainer);
